import React, {Component} from 'react';
// import $ from 'jquery';
import PageLoader from './loader';
import MainComponent from './MainComponent';
import './css/process-statuses.css';

class ProcessStatuses extends MainComponent {
    constructor() {
        super();
        let thisComponent = this;

        this.state = {
            redis_data: this.noDataPreloader()
        };

        this.state = {
            'redis_load_data': setInterval(function () {
                thisComponent.loadData(global.mainDomainName + '?get_processes_status&only_json', (component, data) => {
                    if (typeof data === 'string') {
                        return;
                    }

                    // if (!isJson(data)) {
                    if (data || typeof data === 'object') {
                        thisComponent.setState({
                            redis_data: data
                        });
                    }
                });
            }, 1000)
        };
    }

    //

    componentWillUnmount() {
        let thisComponent = this;
        let interval_key = thisComponent.get('redis_load_data');
        clearInterval(interval_key);
    }

    generateTableRows() {
        {
            // let data = JSON.parse(this.state.redis_data);
            // console.log("Generating table rows..");
            // console.log(data);
            // console.log(Object.values(data));

            return Object.entries(this.state.redis_data).map((value, i) => {
                // console.log(value);
                // console.log(value[0]);
                let k = value[0];
                let v = value[1];

                let last_online_seconds = parseFloat((new Date().getTime() + -new Date(v).getTime()) / 1000).toFixed(2);

                let style_class;
                if (last_online_seconds > 60) {
                    style_class = "row-red";
                } else if (last_online_seconds < 60) {
                    style_class = "row-green";
                }

                return (
                    <tr key={k} className={style_class}>
                        <td>{k}</td>
                        <td>{v}</td>
                        <td>{last_online_seconds} s</td>
                    </tr>
                );
            });
        }
    }

    noDataPreloader() {
        return (<PageLoader/>);
    }

    render() {
        if (this.state.redis_data == null) return this.noDataPreloader();
        // console.log('rendering...');
        return (
            <table className="table">
                <thead>
                <tr>
                    <th scope="col">Process Name</th>
                    <th scope="col">Last Update Time</th>
                    <th scope="col">Last Online Seconds</th>
                </tr>
                </thead>
                <tbody>
                {this.generateTableRows()}
                </tbody>
            </table>
        );
    }
}

export default ProcessStatuses;



// WEBPACK FOOTER //
// ./src/components/ProcessStatuses.js